// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__PKpE0","title":"AfterBackImages_title__3_UmN","images":"AfterBackImages_images__1okPF"};